import variant_annotation from "@/methods/variant_annotation";
import { store } from '@/store'

export default {

    /*
    *
    *
    */
    generateGeneNameLocations() {
        if (Object.keys(store.getters.getVariants).length > 0) {
            if ("snvs" in store.getters.getVariants) {
                for (let key in store.getters.getVariants["snvs"]) {
                    if("UTA_Adapter" in store.getters.getVariants["snvs"][key]) {
                        if ("UTA_Adapter" in store.getters.getVariants["snvs"][key]) {
                            let gene_name = store.getters.getVariants["snvs"][key]["UTA_Adapter"]["gene_name"] + ":" + store.getters.getVariants["snvs"][key]["UTA_Adapter"]["variant_exchange"]
                            store.dispatch('setGeneNameLoc',[gene_name,key])
                        }
                    }
                }
            } else {
                console.log("no snvs")
            }
        } else{
            console.log("no data")
        }
    },
    /*
    * If a variant view is requested, a single biomarker is selected among the already loaded biomarkers and displayed in detail.
    * This function loads the active biomarker from the store, and requests the server if it has not already been loaded.
    *
    */
    async loadActiveBiomarkerSNV(qid) {

        // get genomic location of active biomarker
        await this.generateGeneNameLocations()

        let genompos = store.getters.getGeneNameLoc(qid)
        let performQuery = false

        let oncokb_key = ""
        if (localStorage.getItem("oncokbKey") === null) {
           oncokb_key = ""
        } else {
           oncokb_key = localStorage.getItem("oncokbKey")
        }

        let snv_active = false
        if ((qid) && ("snvs" in store.getters.getVariants)) {
            if (!(genompos in store.getters.getVariants["snvs"]))
                {performQuery = true}
        }
        if (!("snvs" in store.getters.getVariants)) {
            performQuery = true
        }
        if (genompos == null) {performQuery=true}
        if (performQuery) {
            // Load data from server
            let query = qid
            await variant_annotation.startRequestVariantList(query,store.getters.getGenomeVersion,oncokb_key)
            await this.generateGeneNameLocations()
            if (qid in store.getters.getGeneNameLocAll) {
                genompos = store.getters.getGeneNameLoc(qid)
                snv_active = true
            }
        } else {
            //alert("no query")
        }

        // get active biomarker type
        /*let types=["snvs","indels","fusions","genes","unidentified"]
        if (snv_active) {
            //alert("snv active")
            let biomarker = {}
            biomarker[genompos] = store.getters.getVariants["snvs"][genompos]
            store.dispatch('setActiveBiomarker', biomarker)
        } else {
            for (let type in store.getters.getVariants) {
                if (qid in store.getters.getVariants[type]) {
                    //alert("active: "+type+": "+genompos)
                    let biomarker = {}
                    biomarker[qid] = store.getters.getVariants[type][qid]
                    store.dispatch('setActiveBiomarker', biomarker)
                } else {
                    //alert(qid+" not found "+type)
                }
            }
        }*/

        let biomarker = {}
        biomarker[genompos] = store.getters.snvs[genompos]

        // set MANE Select as active transcript
        if (Object.keys(biomarker).includes(genompos)) {
            if ("gencode_genomic" in biomarker[genompos]) {
                var active_transcript = biomarker[genompos].gencode_genomic.transcripts[biomarker[genompos].gencode_genomic["MANE_Select_transcript"]]
                store.dispatch('setActiveTranscript',active_transcript)
                //alert("set transcript "+active_transcript+"::::"+JSON.stringify(store.getters.activeTranscript))
            }
        }

        store.dispatch('setActiveBiomarker', biomarker)
        //alert(JSON.stringify(store.getters.activeBiomarker))
    },
    /*
    * If a variant view is requested, a single biomarker is selected among the already loaded biomarkers and displayed in detail.
    * This function loads the active biomarker from the store, and requests the server if it has not already been loaded.
    *
    */
    async loadActiveBiomarkerInDel(qid) {

        //let genompos = store.getters.getGeneNameLoc(qid)
        let genompos = qid
        let performQuery = false

        let oncokb_key = ""
        if (localStorage.getItem("oncokbKey") === null) {
           oncokb_key = ""
        } else {
           oncokb_key = localStorage.getItem("oncokbKey")
        }

        let snv_active = false
        if ((qid) && ("indels" in store.getters.getVariants)) {
            if (!(genompos in store.getters.getVariants["indels"]))
                {performQuery = true}
        }
        if (!("indels" in store.getters.getVariants)) {
            performQuery = true
        }
        if (genompos == null) {performQuery=true}
        if (performQuery) {
            // Load data from server
            let query = qid
            await variant_annotation.startRequestVariantList(query,store.getters.getGenomeVersion,oncokb_key)
            await this.generateGeneNameLocations()
            if (qid in store.getters.getGeneNameLocAll) {
                //genompos = store.getters.getGeneNameLoc(qid)
                genompos = qid
                snv_active = true
            }
        } else {
            //alert("no query")
        }

        let biomarker = {}
        biomarker[genompos] = store.getters.indels[genompos]

        // set MANE Select as active transcript
        if (Object.keys(biomarker).includes(genompos)) {
            if ("gencode_genomic" in biomarker[genompos]) {
                var active_transcript = biomarker[genompos].gencode_genomic.transcripts[biomarker[genompos].gencode_genomic["MANE_Select_transcript"]]
                store.dispatch('setActiveTranscript',active_transcript)
                //alert("set transcript "+active_transcript+"::::"+JSON.stringify(store.getters.activeTranscript))
            }
        }

        store.dispatch('setActiveBiomarker', biomarker)
        //alert(JSON.stringify(store.getters.activeBiomarker))
    },
    async loadActiveBiomarkerGene(qid) {
        let performQuery = false

        let oncokb_key = ""
        if (localStorage.getItem("oncokbKey") === null) {
           oncokb_key = ""
        } else {
           oncokb_key = localStorage.getItem("oncokbKey")
        }

        let snv_active = false
        if ((qid) && ("genes" in store.getters.getVariants)) {
            if (!(qid in store.getters.getVariants["genes"]))
                {
                    performQuery = true
                }
            else {

            }
        }else{}
        if (!("genes" in store.getters.getVariants)) {
            performQuery = true
        }else{}
        if (qid == null) {performQuery=true}
        if (performQuery) {
            await variant_annotation.startRequestVariantList(qid,store.getters.getGenomeVersion,oncokb_key)
        }
        let biomarker = {}
        biomarker[qid] = store.getters.genes[qid]
        //alert(JSON.stringify(biomarker))
        store.dispatch('setActiveBiomarker', biomarker)
    },

    async loadActiveBiomarkerFusion(qid) {
        let performQuery = false

        let oncokb_key = ""
        if (localStorage.getItem("oncokbKey") === null) {
           oncokb_key = ""
        } else {
           oncokb_key = localStorage.getItem("oncokbKey")
        }

        let snv_active = false
        if ((qid) && ("fusions" in store.getters.getVariants)) {
            if (!(qid in store.getters.getVariants["fusions"]))
                {
                    performQuery = true
                }
            else {

            }
        }else{}
        if (!("fusions" in store.getters.getVariants)) {
            performQuery = true
        }else{}
        if (qid == null) {performQuery=true}else{}
        if (performQuery) {
            await variant_annotation.startRequestVariantList(qid,store.getters.getGenomeVersion,oncokb_key)
        }

        let biomarker = {}
        biomarker[qid] = store.getters.fusions[qid]
        store.dispatch('setActiveBiomarker', biomarker)
    },

}
